import axios from 'axios';
import toastr from 'mini-toastr';

export function request(url, method, data, params) {
  return axios.request({
    url,
    data,
    method,
    params,
    headers: {
    },
  }).then((resp) => {
    const rData = resp.data;
    console.log(rData);
    if (rData.status === 0) {
      return Promise.resolve(rData);
    }
    toastr.error(rData.msg);
    if (rData.status === -101) {
      location.href = '#/login';
    }
    return Promise.reject(rData);
  }, (resp) => {
    // console.log(resp);
    const rData = {};
    rData.msg = '网络故障';
    if (resp.response.data && resp.response.data.length < 100) {
      rData.msg = resp.response.data;
    }
    if (resp.response.status === 401) {
      rData.msg = '认证失败，请重新登录';
      window.location.hash = '/login';
    } else if (resp.response.status === 404) {
      rData.msg = '接口URL路径不存在';
    }
    if (rData.status === -101) {
      location.href = '#/login';
    }
    toastr.error(rData.msg);
    return Promise.reject(rData);
  });
}

export function post(url, data, params) {
  return request(url, 'post', data, params);
}
export function put(url, data, params) {
  return request(url, 'put', data, params);
}
export function get(url) {
  return request(url, 'get');
}
export function getParam(url, param) {
  return request(url, 'get', '', param);
}
export function del(url) {
  return request(url, 'delete');
}



// WEBPACK FOOTER //
// ./src/service/httpServer.js